<ui-icon [icon]="icon()" color="charcoal" class="item-icon item-icon--inactive" />
<ui-icon [icon]="iconActive()" color="charcoal" class="item-icon item-icon--active" />
<div class="item-text"><ng-content /></div>
